module.exports = __webpack_public_path__ + "de6068bf97f40206af0b062e262e6213.woff2";